import { NumberRange } from '@blueprintjs/core';
import { PriceRange } from '@retro-ui/api-contract';

export function serialiseRange(range: NumberRange | PriceRange) {
  if (range[0] === undefined && range[1] === undefined) {
    return '';
  }
  return range.join(',');
}
